import Pqp from "../3x1010/Pqp.js";
import Main from "./Main.js";
export default class Istruzioni {
	constructor(userLang, callback) {
		this.userLang = userLang;
		this.mc = undefined;
		this.callback = callback;
		this.canClose = false;
	}


	init(delay) {
		let mc = jQuery("#template-trix-istruzioni").clone();
		mc.attr("id", "istruzioni" + Istruzioni.ENUM++);
		jQuery(".js-trix1010").append(mc);

		mc.on("click", jQuery.proxy(this.dismiss, this))
		this.mc = mc;

		mc.css("opacity", 0);

		for (var x = 0; x < 8; x++) {
			jQuery(".js-instr" + x, this.mc).html(Main.lbl("instr" + x));
		}

		if (Main.that.mobile) {
			jQuery(".js-desktop", this.mc).hide();
			jQuery(".js-mobile", this.mc).show();
		} else {
			jQuery(".js-desktop", this.mc).show();
			jQuery(".js-mobile", this.mc).hide();
		}


		if ((delay) && (delay > 0)) {
			setTimeout(jQuery.proxy(this.show, this), delay);
		} else {
			this.show();
		}
	}

	show() {
		Main.sfoca(true);
		TweenMax.to(this.mc, 0.5, {
			opacity: 1,
			onComplete: jQuery.proxy(this.canInteract, this)
		});

	}

	canInteract() {
		this.canClose = true;
	}

	dismiss() {
		if (this.canClose) {
			if (Pqp.isMobile()) {
				if (!Pqp.isIos()) {
					let element = jQuery(".trix1010").get(0);
					element.requestFullscreen();
				}
			}


			this.mc.off("click")
			Main.sfoca(false);
			TweenMax.to(this.mc, 0.5, {
				opacity: 0,
				onComplete: jQuery.proxy(this.remove, this)
			});
		}
	}

	remove() {
		this.mc.remove();
		this.callback.call();
	}
}

Istruzioni.ENUM = 0;